/* eslint-disable react/jsx-no-undef */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import CardLayout from "../Cards/CardLayout";
import ReactECharts from "echarts-for-react";
import { useFetchData } from "../../customHooks/useGetDashboardData";
import Loader from "../feedBacks/loader";
import CardError from "../feedBacks/CardError";
import NoContent from "../feedBacks/NoContent";
import { REFETCH_CONFIGURATION } from "../../utils/constants";
import { EChartsOption } from "echarts-for-react";
import { useEffect, useMemo, useState } from "react";
import NoDeviceCardError from "../feedBacks/NoDeviceCardError";
import { useUtils } from "../../customHooks/useUtils";

function LoginTrendChart({ user_id }: { user_id: string }) {
  const { FEEDBACK_MESSAGES,  } = useUtils();
  const filterOptions = useMemo(
    () => [
      { key: '7 Days', value: 7 },
      { key: '2 Weeks', value: 14 },
      { key: '1 Month', value: 30 },
    //   { key: '60 Days', value: 60 },
    ],
    []
  );

  const getDateRangeFromDays = (days: number) => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days);
    return {
      start_date: start.toISOString().split("T")[0],
      end_date: end.toISOString().split("T")[0],
    };
  };

  const [days, setDays] = useState<number>(filterOptions[0].value);
  const { start_date, end_date } = getDateRangeFromDays(days);
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const {
    data: loginData,
    isLoading: isDataLoading,
    error,
    refetch,
  } = useFetchData<any>(
    ["/user-login-trends", "fetchUserLoginTrends", user_id],
    `/user-analytics/logins-trend/`,
    {
      start_date,
      end_date,
      user_id,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );
  const loginTrendData = loginData || [];
  const totals = loginTrendData.map((d: any) => d.total);
  const minValue = Math.min(...totals);
  const maxValue = Math.max(...totals);

  const options: EChartsOption = {
    tooltip: {
      trigger: "axis",
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "15%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: loginTrendData.map((d: any) => d.day),
      axisLabel: {
        rotate: 45,
        fontSize: 10,
      },
    },
    yAxis: {
      type: "value",
      min: minValue,
      max: maxValue,
      interval: Math.max(1, Math.ceil((maxValue - minValue) / 5)),
    },
    series: [
      {
        data: loginTrendData.map((d: any) => d.total),
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 8,
        lineStyle: {
          width: 2,
          color: "#5470C6",
        },
        itemStyle: {
          color: "#5470C6",
        },
        areaStyle: {
          opacity: 0.1,
          color: "#5470C6",
        },
      },
    ],
  };
  const isLoading = isDataLoading || isLocalLoading;

  useEffect(() => {
    if (start_date && end_date) {
      setIsLocalLoading(true);
      refetch().finally(() => {
        setIsLocalLoading(false);
      });
    }
  }, [start_date, end_date, user_id, refetch]);

  return (
    <CardLayout
      title={"Login Trends"}
      className="lg:min-w-[570px] flex-1"
      besideTitleComponent={
        <div className="flex !w-full justify-end">
          <select
            onChange={(e) => setDays(parseInt(e.target.value, 10))}
            value={days}
            className="cursor-pointer flex items-center justify-center max-w-[30%] py-1 px-2 rounded-full bg-[#E5E5E5] text-primary-blackMain text-[10px]"
          >
            {filterOptions.map((item) => (
              <option
                key={item.key}
                value={item.value}
                className="text-primary-blackLight cursor-pointer"
              >
                {item.key}
              </option>
            ))}
          </select>
        </div>
      }
      besideComponentStyle="flex-1 !justify-end"
    >
      <div className="flex flex-col h-full w-full">
        {isLoading ? (
          <div className="flex justify-center items-center h-full w-full">
            <Loader />
          </div>
        ) : error ? (
          (error as any).response?.data?.detail ? (
            <NoDeviceCardError
              message={FEEDBACK_MESSAGES.NO_DEVICE}
              className="!max-h-[150px]"
            />
          ) : (
            <CardError
              message={FEEDBACK_MESSAGES.ERROR}
              className="!h-[100px]"
            />
          )
        ) : loginTrendData?.length === 0 ? (
          <NoContent message={FEEDBACK_MESSAGES.NO_DATA} />
        ) : (
          <div className="h-full w-full relative p-0">
            <ReactECharts option={options} />
          </div>
        )}
      </div>
    </CardLayout>
  );
}

export default LoginTrendChart;
